/*
 * Atomz query-auto-complete adapter.
 *
 * Loaded after atomz-search.js and overrides AtomzSearch.adapter.query when the
 * Atomz header section is set to the Atomz provider. Self-guards, so it is
 * inert for any other provider or a blank endpoint.
 *
 * Contract, read off the az-search-bar theme extension bundle:
 *   POST <endpoint>  Content-Type: application/json  body { user_query, shop }
 *   returns a flat array; each row carries
 *     titleForSuggester  product title
 *     handle             product handle, for /products/<handle>
 *     price              MAJOR units (122 means $122.00)
 *     compareAtPrice     major units
 *     featuredMedia      array of image URLs
 *     discoveryPrompts   array of natural-language phrases
 *     @search.text       description
 *   There is no vendor field, so Brands stays empty for this provider and
 *   discoveryPrompts drive Suggested searches instead.
 */
(function () {
  'use strict';

  var S = window.AtomzSearch;
  if (!S || !S.adapter || !S.adapter.config) return;

  var cfg = S.adapter.config;
  if (cfg.provider !== 'atomz' || !cfg.endpoint) return;

  var toCents = function (v) {
    if (v === null || v === undefined || v === '') return null;
    var n = parseFloat(String(v).replace(/[^0-9.\-]/g, ''));
    if (isNaN(n)) return null;
    return Math.round(cfg.priceUnit === 'major' ? n * 100 : n);
  };

  S.adapter.query = function (term) {
    return fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_query: term,
        shop: (window.Shopify && window.Shopify.shop) || window.location.host
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('atomz ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var rows = Array.isArray(data) ? data : (data && (data.results || data.products)) || [];

        var products = rows.map(function (r) {
          var img = Array.isArray(r.featuredMedia) ? r.featuredMedia[0] : r.featuredMedia;
          return {
            title: r.titleForSuggester || r.title || '',
            url: r.handle ? '/products/' + r.handle : r.url || '#',
            vendor: r.vendor || r.brand || '',
            image: img || '',
            price: toCents(r.price)
          };
        });

        /*
         * discoveryPrompts are written phrases ("men's basketball shoes"),
         * which is the whole point of a natural-language search entry.
         * Shopify's own suggester returns style-code noise here instead.
         */
        var seen = {};
        var queries = [];

        rows.forEach(function (r) {
          var prompts = r.discoveryPrompts;
          if (!Array.isArray(prompts)) return;
          prompts.forEach(function (p) {
            var key = String(p).toLowerCase();
            if (p && !seen[key]) {
              seen[key] = 1;
              queries.push(p);
            }
          });
        });

        var brands = [];
        var brandSeen = {};

        products.forEach(function (p) {
          if (p.vendor && !brandSeen[p.vendor]) {
            brandSeen[p.vendor] = 1;
            brands.push({ title: p.vendor, url: '/search?q=' + encodeURIComponent(p.vendor) });
          }
        });

        return {
          products: products,
          brands: brands.slice(0, 8),
          queries: queries.slice(0, 8)
        };
      });
  };
})();
